import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.a5{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.ax{border:none;}.ssr-plugin'
import '.ay{background-color:transparent;}.ssr-plugin'
import '.ei{border-radius:0px;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.e0{position:sticky;}.ssr-plugin'
import '.ej{top:4rem;}.ssr-plugin'
import '.ek{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.el{padding-bottom:1rem;}.ssr-plugin'
import '.a2{margin-bottom:1rem;}.ssr-plugin'
import '.em{border-bottom:var(--blue-border);}.ssr-plugin'
import '.x{position:fixed;}.ssr-plugin'
import '.c8{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.en{bottom:0px;}.ssr-plugin'
import '.dm{z-index:9999;}.ssr-plugin'
import '.eo{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cw{justify-content:flex-end;}.ssr-plugin'
import '.bu{flex:1;}.ssr-plugin'
import '.aj{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bn bp a5 bk ax ay ei"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="i m ab"
    >
      <div className="e0 ej ek ae el a2 em i"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="x c8 bi bj en dm ae eo i m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bp i cw em"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bu aj">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
